import React from "react";
import SimpleTable from "../components/SimpleTable";
import Time from "../lithic/Moment";
import _ from "lodash";
import { Chip } from "@material-ui/core";

export default function AuditLogsTable({ auditLogs, className }) {
  const includeMessages = _.some(auditLogs, (al) => !_.isEmpty(al.messages));
  const includeBy = _.some(auditLogs, "actor");
  const includeReason = _.some(auditLogs, "reason");
  return (
    <SimpleTable
      className={className}
      tableProps={{ size: "small" }}
      headers={concat(
        ["Audit Logs", "At", "From", "To"],
        includeMessages && "Messages",
        includeBy && "By",
        includeReason && "Reason"
      )}
      rows={auditLogs}
      getKey={(row) => row.at}
      toCells={(row) =>
        concat(
          [
            row.event,
            <Time key={1} format="MMM DD, YYYY HH:mm:ss">
              {row.at}
            </Time>,
            row.fromState,
            row.toState
          ],
          includeMessages && (
            <div style={{ maxWidth: "300px" }}>
              {row.messages?.map((msg, index) => (
                <div
                  key={index}
                  style={{
                    marginBottom: "4px",
                    padding: "2px 6px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "4px",
                    fontSize: "0.85rem",
                    fontStyle: "italic"
                  }}
                >
                  {msg}
                </div>
              ))}
            </div>
          ),
          includeBy && actor(row.actor),
          includeReason && row.reason
        )
      }
    />
  );
}

function concat(...values) {
  return _.flatten(_.filter(values, (x) => x !== false));
}

function actor(a) {
  if (!a) return <span style={{ color: "#999" }}>System</span>;

  const getActorTypeColor = (type) => {
    switch (type) {
      case "Boom::Customer":
        return "primary";
      case "Boom::Admin":
        return "secondary";
      default:
        return "default";
    }
  };

  const getActorTypeLabel = (type) => {
    switch (type) {
      case "Boom::Customer":
        return "Customer";
      case "Boom::Admin":
        return "Admin";
      case "Boom::Partner":
        return "Partner";
      default:
        return type?.split("::").pop() || "Unknown";
    }
  };

  return (
    <div>
      <div style={{ marginBottom: "4px", fontSize: "0.875rem" }}>
        {a.name || "Unknown User"}
      </div>
      <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
        <Chip
          size="small"
          label={getActorTypeLabel(a.type)}
          color={getActorTypeColor(a.type)}
          variant="outlined"
        />
        {a.email && (
          <span style={{ fontSize: "0.75rem", color: "#666" }}>{a.email}</span>
        )}
      </div>
    </div>
  );
}
